var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyrightCert"},[_c('img',{staticClass:"copyrightCert-img",attrs:{"src":_vm.certImg,"alt":"版权登记"}})])}
var staticRenderFns = []

export { render, staticRenderFns }